export enum Interactions {
  SubscriptionCancel = 'subscription_cancel',
  SubscriptionUpm = 'subscription_upm',
  SubscriptionPayNow = 'subscription_pay_now',
}
